<template>
  <div class="section-stats">
    <div class="stats-container">
      <div
        v-for="(stat, idx) in displayStats"
        :key="idx"
        class="stat-item"
      >
        <div class="stat-value">
          <span class="stat-number">{{ formatNumber(stat.value) }}</span>
          <span class="stat-unit">{{ stat.unit }}</span>
        </div>
        <div class="stat-label">{{ stat.label }}</div>
      </div>
    </div>
  </div>
</template>

<script>
const DEFAULT_STATS = [
  { value: 1600, unit: '곳', label: '도입 병원' },
  { value: 313000, unit: '곳', label: '인증서 수신 환자' },
  { value: 592000, unit: '곳', label: '누적 인증서 발행' },
];

export default {
  name: 'SectionStats',

  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    displayStats() {
      if (this.data?.stats && this.data.stats.length) {
        return this.data.stats;
      }
      return DEFAULT_STATS;
    },
  },

  methods: {
    formatNumber(num) {
      if (typeof num !== 'number') return num;
      return num.toLocaleString('ko-KR');
    },
  },
};
</script>

<style scoped>
.section-stats {
  background: #141c26;
  padding: 48px 24px;
}

.stats-container {
  max-width: 900px;
  margin: 0 auto;
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.stat-item {
  text-align: center;
}

.stat-value {
  display: flex;
  align-items: baseline;
  justify-content: center;
  gap: 4px;
}

.stat-number {
  color: #fff;
  font-size: 36px;
  font-weight: 800;
  letter-spacing: -0.5px;
}

.stat-unit {
  color: rgba(255, 255, 255, 0.7);
  font-size: 16px;
  font-weight: 500;
}

.stat-label {
  color: rgba(255, 255, 255, 0.6);
  font-size: 14px;
  margin-top: 8px;
}
</style>
